import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ spacing }) => ({
    spinner: {
        position: "absolute",
        right: spacing(1),
    },
    ui_select: {
        marginBottom: ({ gutterBottom }) => (gutterBottom ? spacing(2) : 0),
    },
}));
//# sourceMappingURL=ui_select.css.js.map